import { render, staticRenderFns } from "./Marketplaces.vue?vue&type=template&id=dd9b1d44&scoped=true"
import script from "./Marketplaces.vue?vue&type=script&lang=js"
export * from "./Marketplaces.vue?vue&type=script&lang=js"
import style0 from "./Marketplaces.vue?vue&type=style&index=0&id=dd9b1d44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9b1d44",
  null
  
)

export default component.exports